import { updateSmsMethod } from '../../../../actions/siteadmin/SmsMethod/updateSmsMethod';
import { demoRestriction } from '../../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    const isEdit = true;
    await dispatch(updateSmsMethod(values, isEdit));
}

export default submit;